<template>
  <div
    class="modal-container"
    v-if="anyModalShown"
  >
    <div class="modal-overlay">
      <client-create-modal v-if="modalStates.client.create.shown" />
      <client-edit-modal v-if="modalStates.client.edit.shown" />
      <project-create-modal v-if="modalStates.project.create.shown" />
      <project-edit-modal v-if="modalStates.project.edit.shown" />
      <room-create-modal v-if="modalStates.room.create.shown" />
      <room-edit-modal v-if="modalStates.room.edit.shown" />
      <measurement-create-modal v-if="modalStates.measurement.create.shown" />
      <measurement-edit-modal v-if="modalStates.measurement.edit.shown" />
      <assemblychecklist-view-modal v-if="this.modalStates.assemblyChecklist.view.shown" />
      <changelog-modal v-if="this.modalStates.changelog.view.shown" />
    </div>
  </div>
</template>

<script>
import ClientCreateModal from "./client-create-modal.vue";
import ClientEditModal from "./client-edit-modal.vue";
import ProjectCreateModal from "./project-create-modal.vue";
import ProjectEditModal from "./project-edit-modal.vue";
import RoomCreateModal from "./room-create-modal.vue";
import RoomEditModal from "./room-edit-modal.vue";
import MeasurementCreateModal from "./measurement-create-modal.vue";
import MeasurementEditModal from "./measurement-edit-modal.vue";
import AssemblychecklistViewModal from "./assemblychecklist-view-modal.vue";
import ChangelogModal from "./changelog-modal.vue";

export default {
  name: "modal-container",
  components: {
    ClientCreateModal,
    ClientEditModal,
    ProjectCreateModal,
    ProjectEditModal,
    RoomCreateModal,
    RoomEditModal,
    MeasurementCreateModal,
    MeasurementEditModal,
    AssemblychecklistViewModal,
    ChangelogModal
  },
  watch: {
    anyModalShown: function() {
      this.$emit("isModalOpen", this.anyModalShown);
      if (this.anyModalShown) {
        document.querySelector("html").classList.add("modal-is-open");
      } else {
        document.querySelector("html").classList.remove("modal-is-open");
      }
    }
  },
  computed: {
    modalStates() {
      return this.$store.getters.getModalStates;
    },
    anyModalShown() {
      return this.$store.getters.getIsAnyModalOpen;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modal-components/modal-container.vue